import comp from "./RelatedConceptsModal";
export default comp;
